import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { API_LOCALE, isLanguage } from '@/i18n'
import { isServiceError } from '@/services/errors'

/** Código de idioma para la API del PMS (en → gb). */
export function useApiLang(): string {
  const { i18n } = useTranslation()
  return API_LOCALE[isLanguage(i18n.language) ? i18n.language : 'es']
}

/** Guardado con estado "Un momento…" y mensaje de error junto al botón (DESIGN.md §4). Sin conexión, lo dice. */
export function useSave() {
  const { t } = useTranslation()
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const run = useCallback(
    async <T,>(action: () => Promise<T>): Promise<T | null> => {
      setSaving(true)
      setError(null)
      try {
        return await action()
      } catch (e) {
        setError(isServiceError(e) && e.code === 'offline' ? t('v2.ds.offline') : t('v2.legacy.error.Error_has_ocurred_try_again_or_contact_us'))
        return null
      } finally {
        setSaving(false)
      }
    },
    [t],
  )
  return { saving, error, run, clearError: () => setError(null) }
}
